import React, { forwardRef } from 'react'
import cx from 'classnames'

import styles from './Input.module.scss'
import { useFormControl } from '../FormControl'

const Input = forwardRef(({ className, ...props }, ref) => {
  const { isInvalid } = useFormControl()

  return <input className={cx(styles.Control, { [styles.Invalid]: isInvalid }, className)} {...props} ref={ref} />
})

export default Input
